import AvailableBrandsModal from "components/BrandView/Modal/AvailableBrandsModal/AvailableBrandsModal";
import EditBrandModal from "components/BrandView/Modal/EditBrandModal/EditBrandModal";
import Datatable from "components/Core/DataTable";
import useCatalogs from "hooks/useCatalogs";
import html2pdf from "html2pdf.js";
import $ from "jquery";
import Papa from 'papaparse';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import NotificationAlert from "react-notification-alert";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	Form,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from "reactstrap";
import okIMG from "../assets/img/ok.png";
import { ReactComponent as UploadIcon } from "../assets/img/upload.svg";
import ConfirmationAlertTwo from "components/ConfirmationAlert/ConfirmationAlertTwo";
import { MotionButton } from "../components/Core/MotionStrap";
import * as modalCSVcss from "../components/Supplier/css/modalUploadCSV.module.css";
import Brand from "../lib/Core/Backend/Controllers/Brand";
import Category from "../lib/Core/Backend/Controllers/Category";
import Supplier from "../lib/Core/Backend/Controllers/Supplier";
import Notify from "../lib/Utils/Alert";
import { BsInfoCircle } from "react-icons/bs";
import Utils from "../lib/Utils/Utils";
import Spinner from 'react-bootstrap/Spinner';

const mapKeys = {
	brandCategory: 'category',
	description: 'description',
	id: 'brandId',
	logoUuid: '',
	lowerLimit: 'lowInvThres',
	name: 'name',
	redemptionInstructions: 'redeemInstruct',
	termsAndConditions: 'terms',
	currency: 'currency',
	regionName: "regionName"
}

function BrandView(props)
{
	const {token} = props
	const {categories} = useCatalogs();
	const brandsCtl = useMemo(() => new Brand(token),[token]);
	const categoriesCtl = useMemo(() => new Category(token),[token]);
	const supplierCtl = useMemo(() => new Supplier(token),[token]);
	const [modal, setModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [downloadBrandsModal, setDownloadBrandsModal] = useState(false);
	const [regionField,setRegionField] = useState(false)
	const [newApiBrandData,setNewApiBrandData] = useState([])
	const toggleDownloadBrandsModal = () =>
	{
		setDownloadBrandsModal(!downloadBrandsModal)
	}
	// // const {currencies} = useCatalogs();
	// // const {region} = useCatalogs()
	
	const [upload, setUpload] = useState(false);
	const [activeOp, setActiveOp] = useState("");
	const [activeOpText, setActiveOpText] = useState("");
	const [operativeRow, setOperativeRow] = useState({});
	const [activeCat, setActiveCat] = useState(-1);
	const [loading, setLoading] = useState(true);
	const [availableBrands, setAvailableBrands] = useState([]);
	const [showAlertMessage, setShowAlertMessage] = useState(false)
	const [initialState, setInitialState] = useState({})
	const [category,setCategory] = useState("");
	const [categoryOption,setCategoryOption] = useState([])
	const [name,setName] = useState("")
	const [description,setDescription] = useState("")
	const [region,setRegion] = useState("")
	const [regionOption,setRegionOption] = useState([]);
	const [currency,setCurrency] = useState("")
	const [currencyOption,setCurrencyOption] = useState([]);
	const [redem,setRedem] = useState("");
	const [termscondition,setTermsCondition] = useState("");
	const [stock,setStock] = useState("")
	const [image,setImage] = useState(null)
	const [defaultCategory,setDefaultCategory] = useState("");
	const [defaultRegion,setDefaultRegion] = useState("");
	const [defaultCurrency,setDefaultCurrency] = useState("");
	const [edit,setEdit] = useState(false)
	const [id,setId] = useState("")
	const [lastUpdated,setLastUpdated] = useState("");
	const isMounted = useRef(null);
	const [fileCsv, setFileCsv] = useState(null);
	const [warningModal,setWarningModal] = useState(false);
	const [activate,setActivate] = useState(true);
    const form = useRef();
	const table = useRef();
	const alert = useRef();
	const logoControl = useRef();
	const brands = useRef();
	const toggleWarning = () => setWarningModal(!warningModal)
	const [brandsLoading, setBrandsLoading] =  useState(false);
	const [deleteBrandLoading, setDeleteBrandLoading] = useState(false);
	const [barndSave,setBrandSave] = useState(false)
	const [loader,setLoader] = useState(true)
	const [showTooltip, setShowTooltip] = useState(false);
	const dollar = new Intl.NumberFormat('en-US', {
		style: "currency",
		currency: "USD",
	});
	const stayModal = () => setShowAlertMessage(false)
	
	let csv;
	let pdf;

	const header = [
		{
			title: 'Logo', data: 'name', sortable: true, render: (data, type, row) =>
			{
				let ret;
				switch (type)
				{
					case "display":
						ret = `<div class="ncentiva-brand-logo-block" style="background-image: url('${brandsCtl.logo(data, true, row.updatedAt)}');"></div>`;
						break;
					case "type":
						ret = "html";
						break;
					default:
						ret = data;
						break;
				}
				return ret;
			},
			width: "10%"
		},
		{
			title: 'Brand', data: 'name', sortable: true, searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: (data) => ({label: data, value: data})
		},
		{
			title: 'Category', data: 'brandCategory', sortable: true, searchable: true,
		},
		{
			title: 'Region', data: 'regionName', sortable: true, searchable: true,
		},
		{
			title: 'Currency', data: 'currencyName', sortable: true, searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: (data) => ({label: data, value: data})
		},
		{
			title: 'Status', data: 'isActive', sortable: true, searchable: true, render:(data)=>{
			 switch (data)
			  {
				case true:
				return `Active`;
				case false:
				return `Inactive`
				
				default:
				return data
			  }
			
			}
		}
	];

	

	const fillCatalog = () =>
	{
		
		if (form.current)
		{
			
			////Utils.FillDropdown(form.current.currency, currencies.sort((a, b) => a.name.localeCompare(b.name)), null, null, null, (cat) => cat.id);
			// Utils.FillDropdown(form.current.category, categories);
			//Utils.FillDropdown(form.current.region, region,null,null,null,(cat)=> cat.name );
			// if (activeCat !== -1)
			// 	form.current.category.value = activeCat;
		}
	}
	const closeMainModal = () => {
		        setRegionField(false)
				setName("");
				setStock("");
				setImage("");
				setDescription("");
				setRedem("");
				setTermsCondition("");
				setCategory("");
				setCurrency("");
				setRegion("");
				setDefaultCategory("")
				setDefaultCurrency("")
				setDefaultRegion("")
				setEdit(false)
				setLastUpdated("")
		if (activeOp === 'Add New') {
			
			let hasChanges = false
			form.current.forEach(el => {
				if (!!el.value && el.value !== '-1') {
					hasChanges = true
				}
			})

			if (hasChanges) {
				setShowAlertMessage(true)
			} else {
				setModal(false)
			}

		} else {
			
			form.current.brandCategory = {value: activeCat}
			const formHasChanges = modelChange(initialState, form.current)
			if (formHasChanges){
				setShowAlertMessage(true)
			} else {
				setModal(!modal)
				setName("");
				setStock("");
				setImage("");
				setDescription("");
				setRedem("");
				setTermsCondition("");
				setCategory("");
				setCurrency("");
				setRegion("");
				setDefaultCategory("")
				setDefaultCurrency("")
				setDefaultRegion("")
				setEdit(false)
			}
		}
	}

	const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}

	const leaveAllModal = () => {
		setShowAlertMessage(false)
		setModal(false)
	}

	const toggle = () =>
	{
		setModal(!modal)
	};
	const toggleConfirm = () => setConfirmModal(!confirmModal);

	function goToDashboard(row)
	{
		document.location.href = `/admin/brands/dashboard/${row.data().id}`;
	}

	function prepareToAdd()
	{
		toggle();
		setActiveOp("Add New");
		setActiveOpText("Please provide the information for the new brand.");
		if (form.current)
			form.current.reset();
	}

	function prepareToEdit(row)
	{
		setEdit(true)
		toggle();
		setActiveOp("Edit");
		setActiveOpText("Edit the required data for this brand");
		setOperativeRow(row);
		const rowData = row?.data();
		setName(rowData?.name)
		setStock(rowData?.lowerLimit)
		setImage(rowData?.name)
		setActivate(rowData?.isActive)
		setDescription(rowData?.description)
		setRedem(rowData?.redemptionInstructions)
		setTermsCondition(rowData?.termsAndConditions)
		setCategory(rowData?.brandCategoryId)
		setCurrency(rowData?.currency)
		setRegion(rowData?.region)
		const updateoption = {
			value: rowData?.brandCategoryId,
			label: rowData?.brandCategory
		}
		setDefaultCategory(updateoption)
		const updateregion = {
			value: rowData?.region,
			label: rowData?.regionName,
		}
		setDefaultRegion(updateregion)
		const updatecurrency = {
			value: rowData?.currency,
			label: rowData?.currencyName
		}
		setDefaultCurrency(updatecurrency)
		setId(rowData?.id)
		setLastUpdated(rowData?.updatedAt)


		// if (form.current)
		// {
		// 	const rowData = row.data();
		// 	setInitialState(rowData)
		// 	form.current.reset();
		// 	setActiveCat(rowData.brandCategoryId);
		// 	form.current.brandId.value = rowData.id;
		// 	form.current.name.value = rowData.name;
		// 	// form.current.region.value = rowData.regionName;
		// 	// form.current.currency.value = rowData.currency;			;
		// 	form.current.description.value = rowData.description;
		// 	form.current.redeemInstruct.value = rowData.redemptionInstructions;
		// 	form.current.terms.value = rowData.termsAndConditions;
		// 	form.current.lowInvThres.value = rowData.lowerLimit;
		// 	form.current.logoFile.dataset.hasFile = rowData.name;
		// 	// logoControl.current.style.backgroundImage = `url('${brandsCtl.logo(rowData.name)}')`;
		// 	document.getElementById("lastEdited").innerText = `Last edited on: ${rowData.updatedAt}`
		// }
	}

// useEffect(()=>{
	

// },[downloadBrandsModal])

const fetchApiresponse = () =>{
	brandsCtl.allAvaiable((data)=>{
		if(data && !data.error){
			// console.log(data.result);
			const datas = data.result
			setNewApiBrandData(datas)
			setLoading(false)
		}
		
		
	});
}

	function addEditBrandLoading(){
		setTimeout(() => {
			setBrandsLoading(false);
		}, 1500);
	}

	const saveBrandLoading = () =>{
		setTimeout(() => {
			setBrandSave(false);
		}, 1500);
	}
	
	function finishOperation()
	{
		setBrandsLoading(true);
		let brandInfo = {
			brandCategory:category,
			name:name,
			description:description,
			redemptionInstructions:redem,
			termsAndConditions:termscondition,
			lowerLimit:stock,
			region:region,
			currency:currency,
			isActive:activate

		}
		if(category === "" || category === undefined){
			Notify(alert,"danger","Please select category");
			addEditBrandLoading()
			return;
		}
		if(name === "" || name === undefined){
			Notify(alert,"danger","Please select name");
			addEditBrandLoading()
			setBrandSave()
			return;
		}
		if(currency === "" || currency === undefined){
			Notify(alert,"danger","Please select currency");
			addEditBrandLoading()
			return;
		}
		if(region === "" || region === undefined){
			Notify(alert,"danger","Please select region");
			addEditBrandLoading()
			return;
		}
		if(stock === "" || stock === undefined){
			Notify(alert,"danger","Please put stock");
			addEditBrandLoading()
			return;
		}
		if(image === "" || image === undefined || image === null) {
			Notify(alert,"danger","Please select any Image");
			addEditBrandLoading()
			return;
		}

		switch (activeOp)
		{
			case "Add New":
				brandsCtl.add(brandInfo, image, data =>
				{
					if(data?.status === 403){
						toggleWarning();
						addEditBrandLoading()
						toggle();
						return;
					}
					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						addEditBrandLoading()
					}
					else
					{
						table.current.dataTable.row.add(data).draw();
						Notify(alert,"success","Brand added successfully")	
						addEditBrandLoading()
						toggle();
						
					}
					
				});
				break;
			case "Edit":
				brandsCtl.update(id, brandInfo, image, data =>
				{
                  if(data?.status === 403){
					toggleWarning();
					addEditBrandLoading()
						toggle();
						return;
					}

					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						addEditBrandLoading()
					}
					else
					{
						Notify(alert,"success","Brand edit successfully")
						data.edited = true;

						operativeRow.data(data);
						operativeRow.invalidate().draw();
						addEditBrandLoading()
						toggle();
					}
					
				});
				break;
			default:
		}
	}

	function remove(row)
	{
		setOperativeRow(row);
		toggleConfirm();
	}

	function deleteBrandsLoading(){
		setTimeout(() => {
			setDeleteBrandLoading(false);
		}, 1500);
	}

	function confirmRemoval()
	{
		setDeleteBrandLoading(true);
		const row = operativeRow;
		brandsCtl.remove(row.data().id, data =>
		{
			if(data?.status === 403){
				toggleWarning();
				deleteBrandsLoading()
				toggleConfirm();
				return;
			}
			if (!data || data.error)
			{
				if (data.status === 500){
					Notify(alert, "danger", "You cannot remove a Brand that has Card Types associated with it.");
					deleteBrandsLoading()
				}
				else{
					Notify(alert, "danger", data.error);
					deleteBrandsLoading()
				}
			} else
			{
				Notify(alert,"success","Delete brand successfully")
				const row = operativeRow;
				row.remove().draw();
				setOperativeRow(null);
				deleteBrandsLoading()
			}
			toggleConfirm();
		});
	}

	const setBrands = useCallback(data => {
		setLoader(false)
		let availableBrands = [];
		let idx = 0;
		let brandsData = data.result
		if (table.current && data && data.count > 0)
			table.current.dataTable.clear().rows.add(
				brandsData.map(brand => {
					const catval = categories.find(item => item.id === brand.brandCategory);
					return {
						...brand,
						brandCategoryId: brand.brandCategory,
						brandCategory: !!catval ? catval.name : '...Loading',
						isActive:brand.isActive
					}
				})
			).draw();
		// const getBestSupplier = () =>
		// {
		// 	if (!!brandsData[idx])
		// 	{
		// 		supplierCtl.bestRateForBrand(brandsData[idx].id, data =>
		// 		{
		// 			if (data && !data.error)
		// 			{
		// 				availableBrands.push({...brandsData[idx], bestSupplier: data});
		// 			}
		// 			else
		// 			{
		// 				availableBrands.push({...brandsData[idx], bestSupplier: {error: 'Supplier not available for this brand'}});
		// 			}
		// 			idx++;
		// 			if (idx === brandsData.length)
		// 			{
		// 				brands.current = availableBrands;
		// 				if (isMounted.current)
		// 				{
		// 					setLoading(false);
		// 				}

		// 			}
		// 			getBestSupplier();
		// 		});

		// 	}
		// };
		// getBestSupplier();
	}, [categories])
	

	function onLogoChange(e)
	{
		if (form.current.logoFile.files[0]){
			if(e.target.files[0].size > 5242880){
				Notify(alert, 'danger', 'File size exceeds 5mB')
				e.target.value = null
				logoControl.current.style.backgroundImage = `none`;
				return
			}
			// logoControl.current.style.backgroundImage = `url('${URL.createObjectURL(form.current.logoFile.files[0])}')`;
		} else
			logoControl.current.style.backgroundImage = `none`;
	}

	function downloadCsv()
	{
		
      let brandsData = newApiBrandData.map((brand) => {
			// Basic fields for the brand
			let brandDetails = {
			  'Brand Id': brand.id,
			  'Brand Name': brand.name,
			  Category: categories.find(category => category.id === brand.brandCategory)?.name || 'Unknown',
			  Currency: brand.currencyName,  // Assuming currencyName is in the response
			  Region: brand.regionName,  // Assuming regionName is in the response
			  Description: brand.description?.replace(/\n/g, ' ') || 'No description available',
			  'Redemption Instructions': brand.redemptionInstructions?.replace(/\n/g, ' ') || 'No redemption instructions available',
			  Terms: brand.termsAndConditions?.replace(/\n/g, ' ') || 'No terms available'
			};
		
			if (Array.isArray(brand.supplierBrandListResponses) && brand.supplierBrandListResponses.length > 0) {
				brand.supplierBrandListResponses.forEach((supplier, index) => {
					const supplierIndex = index + 1; // Index starting from 1 for column naming
					brandDetails[`Supplier ${supplierIndex}`] = supplier.supplierName || 'Unknown Supplier';
	
					// Check for maxAmount and minAmount being 0.0, and collect all productNames
					let denominations = supplier.giftCardTypeResponseList
						.filter(giftCard => giftCard?.maxAmount === 0.0 && giftCard?.minAmount === 0.0)
						.map(giftCard => giftCard.productName)
						.join(', ');
	
					// If no matching product names, use the first productName or 'Unknown Denomination'
					if (!denominations) {
						denominations = supplier.giftCardTypeResponseList?.[0]?.productName || 'Unknown Denomination';
					}
	
					brandDetails[`Denomination Supplier ${supplierIndex}`] = denominations;
					brandDetails[`Discount ${supplierIndex}`] = supplier.discount;
				});
			}
			brandDetails.Status = brand.isActive ? 'Active' : 'Inactive';
		
			return brandDetails;
		  }).sort(function (a, b) {
			var textA = a['Brand Name'].toUpperCase();
			var textB = b['Brand Name'].toUpperCase();
			return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
		  });
		  
		csv = Papa.unparse(brandsData);
		const element = document.createElement("a");
		const file = new Blob([csv], {type: 'text/plain'});
		element.href = URL.createObjectURL(file);
		element.download = "Available Brands.csv";
		document.body.appendChild(element); // Required for this to work in FireFox
		element.click();

	}

	function createTable(data)
	{
		let tbl = document.createElement("table");
		let tblHead = document.createElement('thead');
		let tblBody = document.createElement("tbody");

		tbl.setAttribute('id', 'available-brands');

		tbl.classList.add('table', 'table-striped');
		tblHead.classList.add('thead-dark');

		let headers = document.createElement('tr');
		let headersArr = ['Name', 'Category', 'Best Rate','Denominations', 'Discount', 'Fee'];
		headersArr.forEach(header =>
		{
			let cell = document.createElement('th');
			cell.innerHTML = header;

			cell.setAttribute('scope', 'col');
			headers.appendChild(cell);

		});

		data.forEach((brand, idx) =>
		{
			let row = document.createElement('tr');
			row.classList.add('table-row')
			headersArr.forEach(header =>
			{
				let cell;
				switch (header) {
					case 'Name':
						cell = document.createElement('th');
						cell.setAttribute('scope', 'row');
						cell.innerHTML = brand.name;
						cell.classList.add('text-truncate');
						cell.style.maxWidth = '10vw';
						break;
					case 'Best Rate':
						cell = document.createElement('td');
						cell.innerHTML = brand['Best Rate'];
						cell.classList.add('text-truncate');
						cell.style.fontSize = '11px'
						cell.style.maxWidth = '12vw';
						break;
					case 'Denominations':
						cell = document.createElement('td');
						cell.innerHTML = brand['Denominations'];
						cell.classList.add('text-truncate');
						cell.style.fontSize = '11px'
						cell.style.maxWidth = '12vw';
						break;
					case 'Category':
						cell = document.createElement('td');
						cell.innerHTML = brand.category;
						cell.classList.add('text-truncate');
						cell.style.maxWidth = '2vw';
						break;
					case 'Discount':
						cell = document.createElement('td');
						cell.innerHTML = brand.Discount;
						cell.classList.add('text-truncate');
						cell.style.Width = '1vw';
						break;
					default:
						cell = document.createElement('td');
						cell.innerHTML = brand.Fee;
						cell.classList.add('text-truncate');
						cell.style.Width = '1vw';
						break;
				}

				row.appendChild(cell);
			});
			tblBody.appendChild(row);
		})

		tblHead.appendChild(headers);
		tbl.appendChild(tblHead)
		tbl.appendChild(tblBody);
		return tbl;
	}


	function downloadPdf()
	{


	}

	useEffect(() =>
	{
		isMounted.current = true;
		brandsCtl.	all(setBrands);
		return () =>
		{
			isMounted.current = false
		};

	}, [setBrands,finishOperation]);



	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const handleFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
		setFileCsv(event.target.files[0]);
	  };
	  const toggleUpload = () => {
		setUpload(!upload);
		setFileCsv(null)
		setSelectedFile(null)

	}
	
	  const downloadFile = (data) => {
		let brandsData = data?.map((brand) => (
			{
				categoryCode: brand?.categoryCode,
				name: brand?.name,
				description: brand?.description,
				redemptionInstructions : brand?.redemptionInstructions,
				termsAndConditions: brand?.termsAndConditions,
				lowerLimit : brand?.lowerLimit,
				logoUuid: brand?.logoUuid,
				region:brand?.region,
				currency:brand?.currency
			}
		)
	).sort(function (a, b)
	{
		var textA = a.name.toUpperCase();
		var textB = b.name.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	});
	csv = Papa.unparse(brandsData);
	const element = document.createElement("a");
	const file = new Blob([csv], {type: 'text/plain'});
	element.href = URL.createObjectURL(file);
	element.download = "Brands.csv";
	document.body.appendChild(element); // Required for this to work in FireFox
	element.click();
	  };
	
	  const downloadBrandLimit = async () => {
		await brandsCtl.downloadBrand((res) => {
		  if (res && !res.error) {
			downloadFile(res, `Brands.csv`);
		  }
		});
		Notify(alert, "success", "File Succesfully Download");
	  };


	const handleFileUpload =  (event) => {
		setBrandSave(true)
		event.preventDefault();
		const formData = new FormData();
		formData.append("file", selectedFile);
		if (selectedFile === null) {
			Notify(alert, "danger", "please upload a file");
			// setIsProcessing(false);
			saveBrandLoading()
			return false;
		  }
	       brandsCtl.uploadBrand(formData, (res) => {
			if(res?.status === 403){
				toggleWarning();
				toggleUpload();
				saveBrandLoading();
				return;
			}
			
           if (res?.false) {
				Notify(alert, "danger", res.false);
				saveBrandLoading();
			} else if (res?.true) {
				toggleUpload();
				Notify(alert, "success", res.true);
				saveBrandLoading();
				if (setBrands) {
					isMounted.current = true;
					brandsCtl.all(setBrands);
					return () => {
						isMounted.current = false;
					};
				}
			}
			
			
		//   setIsProcessing(true);
		//    if (res === undefined) {
		// 	Notify(alert, "danger", "please upload a file");
		// 	// setIsProcessing(false);
		// 	return false;
		//   } else if (res?.errorMessage) {
		// 	if(res?.errorMessage.includes("Maximum upload size exceeded")){
		// 		Notify(alert,"danger"," CSV File Size Can not be more than 10MB")
		// 	}else{
		// 		Notify(alert, "danger", res?.errorMessage);
		// 	}
		// 	return false;
		//   } else if (!res.errorMessage) {
		// 	// toggleUpload();
		// 	//Notify(alert, 'success', 'File Succesfully Uploaded')
			
			
			
		// 	// setIsProcessing(false);
			
		//   }
		});
	  };


	return (<>
		<NotificationAlert ref={alert}/>
		<ConfirmationAlertTwo stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} />
		<EditBrandModal
			isOpen={modal}
			//getcurrency={getcurrency}
			token={token}
			categoryOption={categoryOption}
			setCategoryOption={setCategoryOption}
			category={category}
			setCategory={setCategory}
			name={name}
			setName={setName}
			description={description}
			setDescription={setDescription}
			currencyOption={currencyOption}
			setCurrencyOption={setCurrencyOption}
			currency={currency}
			setCurrency={setCurrency}
			redem={redem}
			setRedem={setRedem}
			termscondition={termscondition}
			setTermsCondition={setTermsCondition}
			region={region}
			setRegion={setRegion}
			regionOption={regionOption}
			setRegionOption={setRegionOption}
			stock={stock}
			setStock={setStock}
			toggle={toggle}
			onOpened={fillCatalog}
			activeOp={activeOp}
			activeOpText={activeOpText}
			logoControl={logoControl}
			image={image}
			setImage={setImage}
			defaultCategory={defaultCategory}
			setDefaultCategory={setDefaultCategory}
			defaultRegion={defaultRegion}
			setDefaultRegion={setDefaultRegion}
			defaultCurrency={defaultCurrency}
			setDefaultCurrency={setDefaultCurrency}
			edit={edit}
			lastUpdated={lastUpdated}
			setLastUpdated={setLastUpdated}
			onLogoChange={onLogoChange}
			handleCancelClick={closeMainModal}
			setRegionField={setRegionField}
			regionField={regionField}
			handleSaveClick={finishOperation}
			brandsLoading={brandsLoading}
			innerFormRef={form}
			formRef={form}
			activate={activate}
			setActivate={setActivate}
		/>
		<AvailableBrandsModal
			isOpen={downloadBrandsModal}
			toggle={toggleDownloadBrandsModal}
			isLoading={loading}
			handleDownloadCSVClick={downloadCsv}
			handleDownloadPDFClick={downloadPdf}
			handleCloseClick={toggleDownloadBrandsModal}/>
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="d-flex justify-content-between">
								<CardTitle tag="h4">Ncentiva Platform Brand List</CardTitle>
								 <Col md="auto" className="justify-content-end text-align-right">
									<Button
									className="add_brand btn btn-primaryTwo"
									style={{ cursor: "pointer"}}
									type="button"

									onClick={() => toggleUpload()}
									>
										UPLOAD FILE
                            		</Button>

									<MotionButton initial={{x: "-500%", opacity: 0}} className="add_brand btn btn-primaryTwo"   animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5}}}  onClick={prepareToAdd}>
										<i className="fas fa-folder-open " />
										{' '}Add new brand
									</MotionButton>
							
								
									<MotionButton initial={{ x: "-500%", opacity: 0 }} className="add_brand btn btn-primaryTwo"  animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={() => {
										setDownloadBrandsModal(true);
										fetchApiresponse();
									}}>
										<i className="fas fa-download" />
										{' '}view available brands
									</MotionButton>
									</Col>
									</CardHeader>
								
									<CardBody>
									{loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							      :
									<div className="data_table">
									<Datatable
									ref={table}
									columns={header}
									data={null}
									addRemoveButton={{callback: remove}}
									addEditButton={{callback: prepareToEdit}}
									addDashButton={{callback: goToDashboard}}
									enableSelectFilters={true}
									options={{
										dom: 'tip',
										lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
										saveState: false,
									}}
								/>
								</div>
                                 }
									</CardBody>
					</Card>
				</Col>
			</Row>
			<Modal
                    isOpen={upload}
                    toggle={toggleUpload}
                    backdrop="static"
                    centered={true}
                    size="xl"
                  >
                    <ModalHeader toggle={toggleUpload} className="custom_header_colourTwo">
                      {activeOp} Brand
                    </ModalHeader>
                    <Form>
                      <ModalBody>
					  <div className={modalCSVcss.container}>
                          <div className="text mb-3">
							
							<div className="tooltip-container" onMouseEnter={() => setShowTooltip(true)}
									onMouseLeave={() => setShowTooltip(false)} style={{ cursor: "pointer",marginLeft:"32px" }}>
								<p
									className="text-center tooltip-trigger mb-0"
									
								>
									<BsInfoCircle size={20}  />
								</p>
								{showTooltip && (
									<div className="tooltip-content">
									<p>
										You can download a template, add the brands using the format, and
										delete the brands you don’t need to add. 
										</p>
									<p>Please select a file of type CSV and press Save.</p>
									</div>
								)}
    						</div>
							<p className="text_format">Instructions</p>
                          </div>
					
                          <label
                            htmlFor="file"
                            className={modalCSVcss.formContainer}
                          >
                            <UploadIcon />
                            <span>File Upload CSV</span>
						
                            <input
                              type="file"
                              name=""
                              id="file"
                              className={modalCSVcss.dn}
                              onChange={handleFileChange}
                              // ref={file}
                              accept=".csv"
                            />
			
                          </label>
				
                          {fileCsv?.name && (
                            <div className={modalCSVcss.fileSelected} >
                              <p>
                                {fileCsv.name}{" "}
                                <span className="arrow">
                                  <img src={okIMG} alt="" />
                                </span>
                              </p>
                            </div>
                          )}
						</div>
                        <p
                          className="dbuttonc"
                          style={{
                            color: "#2665F2",
                            fontWeight: "900",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                       
                          onClick={() => {
                            downloadBrandLimit();
                          }}
                        >
                          Download Template
                        </p>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={toggleUpload}
                        >
                          Cancel
                        </Button>{" "}
                        <Button
                          type="submit"
                          className="btn btn-primaryTwo"
                          onClick={handleFileUpload}
						  disabled={barndSave}
                        >
                          {!barndSave && "Save"}
						  {
						barndSave && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
			<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>Remove Brand</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the brand "{!!operativeRow && !!operativeRow.data ? operativeRow.data().name : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" className="" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button className="btn btn-primaryTwo" onClick={confirmRemoval} disabled={deleteBrandLoading}>{!deleteBrandLoading && "Yes"}{
						deleteBrandLoading && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}</Button>
				</ModalFooter>
			</Modal>

			<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>
		</div>
	</>);
}

export default BrandView;
